// react
import React from 'react';

// third-party
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

// application
import PageHeader from '../shared/PageHeader';

// data stubs
import theme from '../../data/theme';

const TERMS = [
    {
        title: '1. Ketentuan Umum',
        points: [
            'Dengan mengakses dan menggunakan situs ini, Anda dianggap telah membaca, memahami, dan menyetujui seluruh syarat dan ketentuan yang berlaku.',
            'Hokky Bangunan berhak mengubah syarat dan ketentuan sewaktu-waktu. Perubahan berlaku sejak dipublikasikan di halaman ini.',
            'Pengguna wajib memberikan data yang benar, lengkap, dan terbaru.',
        ],
    },
    {
        title: '2. Akun Pengguna',
        points: [
            'Anda bertanggung jawab menjaga kerahasiaan kata sandi dan seluruh aktivitas yang terjadi di akun Anda.',
            'Segera hubungi kami jika Anda menduga akun digunakan tanpa izin.',
            'Kami berhak menonaktifkan akun yang melanggar ketentuan atau digunakan untuk tindakan yang merugikan.',
        ],
    },
    {
        title: '3. Produk & Harga',
        points: [
            'Harga, stok, dan promo yang tampil dapat berubah sewaktu-waktu tanpa pemberitahuan sebelumnya.',
            'Gambar produk hanya sebagai ilustrasi. Warna dan tampilan asli dapat sedikit berbeda.',
            'Pesanan dapat dibatalkan apabila stok tidak tersedia atau terjadi kesalahan harga yang nyata.',
        ],
    },
    {
        title: '4. Pemesanan & Pembayaran',
        points: [
            'Pemesanan dilakukan melalui alur keranjang, checkout, lalu pembayaran.',
            'Pembayaran dilakukan melalui Transfer Bank Langsung atau HokkyPay sesuai pilihan yang tersedia.',
            'Pesanan harus dibayar dalam 24 jam. Pesanan yang melewati batas waktu dapat dibatalkan otomatis.',
            'Bukti transfer dikirim lewat WhatsApp. Pesanan diproses setelah pembayaran divalidasi oleh admin.',
        ],
    },
    {
        title: '5. Pengiriman',
        points: [
            'Ongkos kirim dihitung saat checkout berdasarkan alamat tujuan, kurir, dan berat barang.',
            'Pengguna wajib mengisi alamat dan nomor telepon penerima dengan benar. Kesalahan data alamat menjadi tanggung jawab pengguna.',
            'Estimasi waktu pengiriman mengikuti layanan kurir dan dapat berubah akibat kondisi di luar kendali kami.',
        ],
    },
    {
        title: '6. Pembatalan, Pengembalian & Komplain',
        points: [
            'Pembatalan pesanan yang belum dibayar dapat dilakukan melalui halaman pesanan.',
            'Jika barang diterima rusak atau tidak sesuai, hubungi kami segera dengan menyertakan foto dan nomor pesanan.',
            'Pengajuan komplain ditinjau oleh tim kami, dan penyelesaiannya mengikuti hasil pemeriksaan.',
        ],
    },
    {
        title: '7. Layanan Jasa Aplikator',
        points: [
            'Layanan jasa berjalan dengan tahapan pengajuan, survey, hasil RAB, pembayaran DP, pengerjaan, dan pelunasan.',
            'Perubahan pekerjaan diajukan melalui revisi pesanan jasa. Biaya revisi dihitung dan disetujui terlebih dahulu.',
            'Pelunasan dilakukan sesuai kesepakatan setelah pekerjaan selesai.',
        ],
    },
    {
        title: '8. Privasi & Data Pribadi',
        points: [
            'Data yang Anda berikan digunakan untuk memproses pesanan, pengiriman, dan layanan pelanggan.',
            'Kami tidak menjual data pribadi Anda kepada pihak lain.',
        ],
    },
];

function SitePageTerms() {
    const breadcrumb = [
        { title: 'Home', url: '/' },
        { title: 'Syarat & Ketentuan', url: '' },
    ];

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Syarat & Ketentuan | ${theme.name}`}</title>
            </Helmet>

            <PageHeader breadcrumb={breadcrumb} />

            <div className="block">
                <div className="container">
                    <div className="document">
                        <div className="document__header">
                            <h1 className="document__title">Syarat &amp; Ketentuan</h1>
                            <div className="document__subtitle">Terakhir diperbarui pada 24 Oktober 2026.</div>
                        </div>
                        <div className="document__content typography">
                            <p>
                                Selamat datang di Hokky Bangunan. Mohon baca ketentuan berikut sebelum menggunakan
                                layanan kami.
                            </p>

                            {TERMS.map((section) => (
                                <React.Fragment key={section.title}>
                                    <h2>{section.title}</h2>
                                    <ul>
                                        {section.points.map((point) => (
                                            <li key={point}>{point}</li>
                                        ))}
                                    </ul>
                                </React.Fragment>
                            ))}

                            <h2>9. Kontak</h2>
                            <p>
                                Pertanyaan seputar ketentuan ini dapat disampaikan ke {theme.contacts.email} atau{' '}
                                {theme.contacts.phone}. Kunjungi juga <Link to="/site/contact-us">halaman kontak</Link>.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default SitePageTerms;
